// Single source of truth for "does this practice get the attendance UI?"
// (status-jump pop-ups, the Attendance review page, the Create Lead advanced
// stage buttons). Reads PracticePreferences.attendance_capture_eligible
// (backend #7084): the backend only enforces attendance capture for a practice
// when the global switch AND this preference are on, so the UI must follow the
// same signal or staff see prompts the backend does not require (or vice versa).
//
// Fails CLOSED: unknown / loading / stale practice → false (production today).
// The 409 date-lock handling (appointmentDateLock.js) is deliberately NOT behind
// this flag — the backend may enforce the lock for practices that are ineligible.
//
// Two readers of one rule: `attendanceUiEnabledFor()` for thunks and utils
// (store access), `useAttendanceUiEnabled()` for components.
import { store } from '../redux/store';

export function attendanceUiEnabledFromState(state, practiceId) {
    const loaded = state?.practice?.practice;
    const prefs = loaded?.preferences;
    if (!prefs) return false;
    // STALE-PRACTICE GUARD (see useIsFollowUpV2Practice): state.practice.practice
    // lags behind a practice switch; only trust the flag for the active practice.
    const activeId = practiceId ?? state?.practiceTreatmentList?.practiceId;
    if (activeId != null && loaded?.id != null && String(loaded.id) !== String(activeId)) return false;
    return prefs.attendance_capture_eligible === true;
}

export function attendanceUiEnabledFor(practiceId) {
    return attendanceUiEnabledFromState(store.getState(), practiceId);
}
